<article class="hvac-accordion-content">
    <ng-content></ng-content>
</article>
